import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {RootState} from 'common/src/redux/store';
import aiContentItemApi from '../../../aiContentItem.api';
import {RemoteAiContentItem} from '../../../aiContentItem.types';
import {
  setItems,
  setItemsError,
  setItemsLoading,
  setLoadedItemsProjectId,
} from '../aiContentProject.slice';

interface LoadAiContentItemsParams {
  projectId: number;
  forceReload?: boolean;
}

const loadAiContentItems = createAsyncThunk<
  RemoteAiContentItem[],
  number | LoadAiContentItemsParams,
  {state: RootState}
>(
  `${BreadcrumbName.AiContentProjectPage}/loadAiContentItems`,
  async (params, {dispatch, getState, rejectWithValue}) => {
    const {projectId, forceReload} =
      typeof params === 'number' ? {projectId: params, forceReload: false} : params;

    const state = getState();
    const currentProjectId = state.aiContentProjectPage?.loadedItemsProjectId;

    // Prevent reloading the same project unless forceReload is true
    if (currentProjectId === projectId && !forceReload) {
      return state.aiContentProjectPage?.items ?? [];
    }

    dispatch(setItemsLoading(true));
    dispatch(setItemsError(null));

    try {
      const items = await aiContentItemApi.getAiContentItemsByProjectId(projectId);
      dispatch(setItems(items));
      dispatch(setLoadedItemsProjectId(projectId));

      return items;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to load items';
      dispatch(setItemsError(errorMessage));

      return rejectWithValue(errorMessage);
    } finally {
      dispatch(setItemsLoading(false));
    }
  },
);

export default loadAiContentItems;
